import {
  border2,
  radius,
  rem,
  spacing,
  token,
  Theme,
} from '@thiememeulenhoff/lit-sdk';
import * as coreTokens from '@thiememeulenhoff/tokens/core';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('header');
export const theme = new Theme(tag);

export const styles = css`
  :host {
    align-items: stretch;
    background-color: ${token('background-secondary')};
    border-block-end: ${border2(1, 'border-strong')};
    display: flex;
    inline-size: 100%;
    inset-block-start: 0;
    justify-content: space-between;
    padding: ${spacing(0, 200)};
    position: fixed;
    transition: top 0.2s ease-in-out;
    ${theme.props([['min-block-size', 'min-block-size', rem(50)]])};
    z-index: 9999;
  }

  :where(a-logo-icon),
  ::slotted([slot='logo']) {
    inline-size: ${rem(40)};
  }

  :where(section) {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 auto;
    gap: ${spacing(100)};
    padding: ${spacing(100, 0)};
  }

  :where(.logo) {
    flex: 0 0 auto;
    margin-inline-end: ${spacing(400)};
  }

  :host([padding='false']) :where(section) {
    gap: 0;
    padding: 0;

    &:where(.start) a-logo-icon,
    &:where(.start) .stream-logo,
    &:where(.start) .stream-title {
      padding-inline-end: ${spacing(100)};
    }
  }

  :where(.bypass-block a) {
    block-size: ${rem(1)};
    color: ${token('text-link-default')};
    inset-block-start: auto;
    overflow: hidden;
    position: absolute;
  }

  :where(.bypass-block) {
    flex: 0 0 auto;
  }

  :where(.bypass-block a:focus) {
    background-color: ${token('background-secondary')};
    block-size: auto;
    border: ${border2(2, 'focus-ring')};
    border-radius: ${radius('small')};
    inline-size: auto;
    inset-block-start: ${rem(75)};
    outline: none;
    padding: ${spacing(75)};
    position: absolute;
    text-decoration: none;
  }

  :where(.start) {
    justify-content: flex-start;
  }

  :where(.center) {
    justify-content: center;
  }

  :where(.end) {
    justify-content: flex-end;
  }

  :where(.stream-title) {
    font-size: ${rem(18)};
    line-height: 1;
  }

  :where(.stream-logo) {
    max-block-size: ${rem(32)};
    max-inline-size: ${rem(120)};
  }

  @media (max-width: ${unsafeCSS(coreTokens.BreakpointSmall)}) {
    :host {
      flex-wrap: wrap;
    }

    :where(.center) {
      justify-content: flex-start;
    }
  }
`;
